import React from "react";
import Panel from "../../../../components/Panel";
import { createPortal } from "react-dom";
import { Button, Select, Tooltip } from "antd";
import { QuestionCircleOutlined } from '@ant-design/icons';
import EyePlotConfig from "../../SimulationContent/components/EyePlotConfig";
import { getChannelContentPromise, updateChannelContentPromise } from "../../../../services/Andes_v2/channel";
import { generateEyeDiagramResult } from "../../../../services/Andes_v2/results/resultCtrl";
import { getEndToEndChannelContent, saveEndToEndChannelContent } from "../../../../services/Andes_v2/endToEndChannel";
import libraryConstructor from "../../../../services/Andes_v2/library/libraryConstructor";
import { CPHY_EYE_MASK } from "../../../../constants/libraryConstants";

class EditEyeDiagramRange extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      eyePlotConfig: {
        waveform_start: "",
        waveform_end: "",
        ui_before_trigger: "1",
        ui_after_trigger: "0"
      },
      eyeMask: { libraryId: "" },
      eyeMaskList: libraryConstructor.getLibraryValues(CPHY_EYE_MASK),
      loading: false,
    }
    this.dialogRoot = document.getElementById('root');
  }

  async componentDidMount() {
    const { isEndToEnd, channelId } = this.props;
    let res = null;
    if (isEndToEnd) {
      res = await getEndToEndChannelContent(channelId);
    } else {
      res = await getChannelContentPromise(channelId);
    }
    if (res && res.hspiceConfig && res.hspiceConfig.eyePlotConfig) {
      this.setState({ eyePlotConfig: res.hspiceConfig.eyePlotConfig, eyeMask: res.hspiceConfig.eyeMask });
    }

    this.channelInfo = res;
  }

  componentDidUpdate(prevProps) {
    const { libraryStatus } = this.props;
    if (prevProps.libraryStatus !== libraryStatus) {
      this.setState({
        eyeMaskList: libraryConstructor.getLibraryValues(CPHY_EYE_MASK)
      })
    }
  }

  recalculate = () => {
    const { channelId } = this.props;
    const { eyePlotConfig, eyeMask } = this.state;
    this.setState({
      error: '',
      loading: true
    })
    generateEyeDiagramResult(channelId, { eyePlotConfig, eyeMask }).then(async () => {
      this.props.cleanEyeDiagram();
      await this.props.getResult();
      this.setState({
        loading: false
      })
    }, error => {
      this.setState({
        error: error,
        loading: false
      })
    })
  }

  footerRender = () => {
    const { loading } = this.state;
    return <div className="eye-edit-button">
      <Button type="primary" size="small" onClick={() => this.recalculate()} loading={loading}>
        Generate
      </Button>
    </div>
  }

  onChange = (_, value) => {
    this.setState({ eyePlotConfig: value })
  }

  onSelectChange = (value) => {
    const libraryInfo = libraryConstructor.getLibrary(CPHY_EYE_MASK, value) || {};
    this.setState({
      eyeMask: {
        libraryId: value,
        fileName: libraryInfo.name,
      }
    });
  }

  closePanel = async () => {
    const { isEndToEnd } = this.props;
    const { eyePlotConfig, eyeMask } = this.state;
    if (isEndToEnd) {
      await saveEndToEndChannelContent({
        ...this.channelInfo,
        hspiceConfig: {
          ...this.channelInfo.hspiceConfig,
          eyePlotConfig,
          eyeMask
        }
      })
    } else {
      await updateChannelContentPromise({
        ...this.channelInfo,
        hspiceConfig: {
          ...this.channelInfo.hspiceConfig,
          eyePlotConfig,
          eyeMask
        }
      })
    }

    this.props.closePanel();
  }

  render() {
    const { eyePlotConfig, error, eyeMask, eyeMaskList } = this.state;
    const eyeMaskNotExist = eyeMask.libraryId && !eyeMaskList.find(item => item.id === eyeMask.libraryId) ? true : false
    const content = (
      <Panel
        className="andes-v2-model-panel"
        position="panel-center-left"
        title="Eye Plot Config"
        zIndex={2000}
        onCancel={() => this.closePanel()}
        width={700}
        draggable
        minHeight={200}
        footer={this.footerRender()}
      >
        <div className="eye-edit-panel-content">
          <div className="setup-input-group-flex-box">
            <label>Eye Mask</label>
            <div style={{ width: `calc(100% - 100px)` }}>
              <Select
                value={eyeMaskNotExist ? eyeMask.fileName : eyeMask.libraryId || "Default"}
                className={`aurora-select ${eyeMaskNotExist ? "setup-select-width-not-exist" : "setup-select-width"}`}
                popupClassName="setup-input-group-select-item-dropdown"
                onChange={this.onSelectChange}
                allowClear={true}
                options={eyeMaskList.map(item => ({ label: item.name, value: item.id }))}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
              />
            </div>
            {eyeMaskNotExist ? <Tooltip
              title="The file was not found, please choose again."
              classNames={{ root: "aurora-tooltip" }}
            >
              <QuestionCircleOutlined className="setup-question-circle-icon" />
            </Tooltip> : null}
          </div>

          <EyePlotConfig
            eyePlotConfig={eyePlotConfig}
            onChange={this.onChange}
          />
          <div className="">{error}</div>
        </div>
      </Panel >
    )
    return createPortal(content, this.dialogRoot)
  }
}

export default EditEyeDiagramRange;